var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon15SecBackwards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 34C29.232 34 35.5 27.732 35.5 20C35.5 12.268 29.232 6 21.5 6C16.7366 6 12.5289 8.3789 10 12.0135",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.341 12.6551L8.42176 13.9182L7.16016 7",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75391 31.8584H7.18945V21.0215L4.5 22.2256V20.749L8.50781 19H8.75391V31.8584Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0094 25.4424L12.5631 19.0615H18.1266V20.5645H13.8727L13.5739 24.0537C14.1012 23.6846 14.6696 23.5 15.2789 23.5C16.275 23.5 17.0573 23.8867 17.6256 24.6602C18.194 25.4336 18.4782 26.4736 18.4782 27.7803C18.4782 29.1045 18.1676 30.1445 17.5465 30.9004C16.9313 31.6562 16.0846 32.0342 15.0065 32.0342C14.0455 32.0342 13.2633 31.7207 12.6598 31.0938C12.0563 30.4668 11.7106 29.5996 11.6227 28.4922H13.0817C13.1696 29.2246 13.3776 29.7783 13.7057 30.1533C14.0397 30.5225 14.4733 30.707 15.0065 30.707C15.61 30.707 16.0817 30.4463 16.4215 29.9248C16.7614 29.3975 16.9313 28.6885 16.9313 27.7979C16.9313 26.96 16.7467 26.2773 16.3776 25.75C16.0143 25.2227 15.5221 24.959 14.901 24.959C14.3854 24.959 13.9723 25.0938 13.6618 25.3633L13.2487 25.7764L12.0094 25.4424Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15SecBackwards);
export default __webpack_public_path__ + "static/media/icon-15sec-backwards.cd8aca841f6571327501869796ef5c40.svg";
export { ForwardRef as ReactComponent };